const Segments = [
  { worplace: 'Kontorsåtervinning' },
  { company: 'Detaljhandel' },
  { company: 'Hotell & restaurang' },
];

export default Segments;
